import Cookies from 'js-cookie';
export var OptanonService = {
    parseGrantedCategories: function () {
        var optanonConsent = Cookies.get('OptanonConsent');
        if (!optanonConsent) {
            return null;
        }
        return {
            required: optanonConsent.includes('C0001:1'),
            performance: optanonConsent.includes('C0002:1'),
            marketing: optanonConsent.includes('C0004:1'),
        };
    },
    isPerformanceGranted: function () {
        var grantedCategories = OptanonService.parseGrantedCategories();
        return grantedCategories !== null && grantedCategories.performance;
    },
    isMarketingGranted: function () {
        var grantedCategories = OptanonService.parseGrantedCategories();
        return grantedCategories !== null && grantedCategories.marketing;
    },
    isAllCategoriesGranted: function () {
        var grantedCategories = OptanonService.parseGrantedCategories();
        return (grantedCategories !== null &&
            grantedCategories.marketing &&
            grantedCategories.performance &&
            grantedCategories.required);
    },
};
